module.exports = __webpack_public_path__ + "img/4.feb08c13.png";